import React from 'react'
import {
  Card,
  CardActions,
  CardTitle,
  CardText
} from 'material-ui-legacy/Card'

import {niceJoin} from '../../lib/formats'
import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'


const UserCard = (props) => {
  // Data can be received either as user or itemData.
  const user = props.user || props.itemData

  const {
    fullName,
    email,
    title,
    formattedPhones,
    address,
    city,
    province,
    postalCode,
    country,
    twitter,
    facebook,
    roles
  } = user.attributes

  return (
    <Card>
      <CardTitle
        title={fullName}
        subtitle={title}
      />

      <CardText>
        <p>
          <strong>Roles:</strong> {niceJoin(roles)}
        </p>
        <p>
          <strong>E-mail:</strong>&nbsp;
          <a href={`mailto:${email}`}>
            {email}
          </a>
        </p>
        {formattedPhones &&
          <p>
            <strong>Phones:</strong> {formattedPhones}
          </p>
        }
        {address &&
          <p>
            <strong>Address:</strong> {address}
          </p>
        }
        {city &&
          <p>
            <strong>City:</strong> {city}
          </p>
        }
        {province &&
          <p>
            <strong>State/Province:</strong> {province}
          </p>
        }
        {country &&
          <p>
            <strong>Country:</strong> {country}
          </p>
        }
        {postalCode &&
          <p>
            <strong>Postal code:</strong> {postalCode}
          </p>
        }
        {twitter &&
          <p>
            <strong>Twitter:</strong> {twitter}
          </p>
        }
        {facebook &&
          <p>
            <strong>Facebook:</strong> {facebook}
          </p>
        }
      </CardText>

      <CardActions>
        {props.editCallback &&
          <EditButton onTouchTap={props.editCallback}/>
        }
        {props.deleteCallback &&
          <DeleteButton
            onTouchTap={props.deleteCallback}
            confirmMessage={
              <p>
                Are you sure you want to delete <strong>{fullName}</strong>?
                There's no undo.
              </p>
            }
          />
        }
        {props.closeCallback &&
          <CloseButton onTouchTap={props.closeCallback}/>
        }
      </CardActions>
    </Card>
  )
}

export default UserCard



// WEBPACK FOOTER //
// ./src/components/Users/UserCard.jsx